import { useEffect, useState } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';

const navItems = [
  { to: '/', label: '首页' },
  { to: '/guides', label: '避雷清单' },
  { to: '/faq', label: '常见问题' },
  { to: '/about', label: '关于我们' },
];

export default function SiteHeader() {
  const [open, setOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  const linkClass = ({ isActive }: { isActive: boolean }) =>
    `font-label text-sm px-3 py-2 rounded-md transition-colors whitespace-nowrap ${
      isActive
        ? 'text-primary-700 bg-primary-50'
        : 'text-foreground-700 hover:text-foreground-950 hover:bg-background-100'
    }`;

  return (
    <header className="sticky top-0 z-50 w-full border-b border-background-200 bg-background-50/95 backdrop-blur">
      <div className="w-full px-4 md:px-8">
        <div className="flex h-16 items-center justify-between gap-4">
          <Link to="/" className="flex items-center gap-3 shrink-0" aria-label="看料避雷社 首页">
            <span className="w-9 h-9 rounded-md bg-accent-500 flex items-center justify-center text-background-50 text-lg">
              <i className="ri-alert-fill"></i>
            </span>
            <span className="flex flex-col leading-tight">
              <span className="font-heading text-lg font-bold text-foreground-950 tracking-tight">看料避雷社</span>
              <span className="hidden sm:block text-[11px] text-foreground-500 font-label tracking-wider">
                入手之前，先看这一眼
              </span>
            </span>
          </Link>

          <nav className="hidden md:flex items-center gap-1" aria-label="主导航">
            {navItems.map((item) => (
              <NavLink key={item.to} to={item.to} className={linkClass} end={item.to === '/'}>
                {item.label}
              </NavLink>
            ))}
          </nav>

          <div className="flex items-center gap-2">
            <Link
              to="/guides"
              className="hidden md:inline-flex items-center gap-2 rounded-md bg-primary-500 px-4 py-2 font-label text-sm text-background-50 hover:bg-primary-600 transition-colors whitespace-nowrap"
            >
              <i className="ri-shield-check-line"></i>
              开始排雷
            </Link>
            <button
              type="button"
              onClick={() => setOpen((v) => !v)}
              className="md:hidden w-10 h-10 flex items-center justify-center rounded-md border border-background-300 text-foreground-800 cursor-pointer hover:bg-background-100 transition-colors"
              aria-label={open ? '关闭菜单' : '打开菜单'}
              aria-expanded={open}
            >
              <i className={open ? 'ri-close-line text-xl' : 'ri-menu-line text-xl'}></i>
            </button>
          </div>
        </div>
      </div>

      {open && (
        <div className="md:hidden border-t border-background-200 bg-background-50">
          <nav className="px-4 py-3 flex flex-col gap-1" aria-label="移动端导航">
            {navItems.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.to === '/'}
                className={({ isActive }) =>
                  `font-label text-sm px-3 py-3 rounded-md ${
                    isActive ? 'text-primary-700 bg-primary-50' : 'text-foreground-700 hover:bg-background-100'
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
            <Link
              to="/guides"
              className="mt-1 inline-flex items-center justify-center gap-2 rounded-md bg-primary-500 px-4 py-3 font-label text-sm text-background-50"
            >
              <i className="ri-shield-check-line"></i>
              开始排雷
            </Link>
          </nav>
        </div>
      )}
    </header>
  );
}